<template>
    <div class="top">
        <header class="header">
            <a href="/" class="logo-link" style="margin-right: 2rem;">
                <img src="../../assets/img/logo.png" alt="logo" class="logo-icon"/>
                <!-- <span>标准学术能力测试</span> -->
            </a>
            <nav class="main-nav">
                <ul class="main-nav-list">
                    <li>
                        <router-link to="/" class="main-nav-link">首页</router-link>
                    </li>
                    <li>
                        <router-link to="" class="main-nav-link" @click.native="onJump('/tda', 'TDA','')">
                            诊断性测试(TDA)
                        </router-link>
                        <div class="floating-window">
                            <div class="triangle"></div>
                            <div class="floating-window-box">
                                <router-link to="" class="main-nav-link"
                                             @click.native="onJump('/tda', 'TDA','TDA-G10')">
                                    TDA-G10
                                </router-link>
                                <router-link to="" class="main-nav-link"
                                             @click.native="onJump('/tda', 'TDA','TDA-G11')">
                                    TDA-G11
                                </router-link>
                                <router-link to="" class="main-nav-link"
                                             @click.native="onJump('/tda', 'TDA','TDA-G12')">
                                    TDA-G12
                                </router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <router-link to="" class="main-nav-link" @click.native="onJump('/caca', 'CACA','')">
                            综合学术能力评估(CACA)
                        </router-link>
                        <div class="floating-window">
                            <div class="triangle"></div>
                            <div class="floating-window-box">
                                <router-link to="" class="main-nav-link"
                                             @click.native="onJump('/caca', 'CACA','CACA-Pre')">CACA-Pre
                                </router-link>
                                <router-link to="" class="main-nav-link"
                                             @click.native="onJump('/caca', 'CACA','CACA-Basic')">CACA-Basic
                                </router-link>
                                <router-link to="" class="main-nav-link"
                                             @click.native="onJump('/caca', 'CACA','CACA-Junior')">CACA-Junior
                                </router-link>
                                <router-link to="" class="main-nav-link"
                                             @click.native="onJump('/caca', 'CACA','CACA-Senior')">CACA-Senior
                                </router-link>
                            </div>
                        </div>
                    </li>
                    <!--<li>
                        <router-link to="/tda" class="main-nav-link">诊断性测试(TDA)</router-link>
                    </li>
                    <li>
                        <router-link to="/caca" class="main-nav-link">综合学术能力评估(CACA)</router-link>
                    </li>-->
                    <!--<li>
                        <router-link to="" class="main-nav-link">综合学术能力评估(CACA)</router-link>
                        <div class="floating-window">
                            <div class="triangle"></div>
                            <div class="floating-window-box">
                                <router-link
                                        to=""
                                        class="main-nav-link"
                                        @click.native="openUrl('https://mp.weixin.qq.com/s/iVbsuq7_uWMQrBKav8mfGg')"
                                >CACA
                                </router-link>
                                <router-link
                                        to=""
                                        class="main-nav-link"
                                        @click.native="openUrl('https://mp.weixin.qq.com/s/lZhiO79mPQOGnab-cYJt-w')"
                                >CACA-Pre
                                </router-link>
                            </div>
                        </div>
                    </li>
                    <li>
                        <router-link to="" class="main-nav-link"
                                     @click.native="openUrl('https://mp.weixin.qq.com/s/5mMWQuQoYJepG9dK8xtwZg')"
                        >信息学综合能力评估(CICA)</router-link>
                    </li>
                    <li>
                        <router-link to="/tda#section-intro" class="main-nav-link">TDA特点</router-link>
                    </li>-->
                    <div class="login-navs">
                        <li><a href="https://student.cssat.cn" class="main-nav-link nav-login">个人登录</a></li>
                        <li><a href="https://school.cssat.cn" class="main-nav-link nav-login">集体登录</a></li>
                    </div>
                </ul>
            </nav>

            <button class="btn-mobile-nav icon-mobile-nav">
                <i class="ph ph-list icon-mobile-nav" name="menu-outline"></i>
                <i class="ph ph-x icon-mobile-nav" name="close-outline"></i>
            </button>
        </header>
    </div>
</template>
<script>
    export default {
        name: 'Header',
        methods: {
            openUrl(url) {
                window.location.href = url;
            },
            onJump(path, key, tab) {
                let that = this;
                that.$router.push(path);
                if (tab) {
                    that.$store.commit('setActiveTab', {key, tab});
                    setTimeout(() => {
                        let el = document.querySelector('.tab-area-container')
                        if (el) {
                            window.scrollTo({
                                top: el.offsetTop - 62,
                                behavior: 'smooth'
                            });
                        }

                    }, 100)
                }else{
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            }
        }
    }
</script>
